import { render, staticRenderFns } from "./mergejliin_zuvluh.vue?vue&type=template&id=53ab3d8e&"
import script from "./mergejliin_zuvluh.vue?vue&type=script&lang=js&"
export * from "./mergejliin_zuvluh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports